export const SITE_STORE = "SITE_STORE";

/********************************  State ********************************/
export const AVAILABLE_SITES = "AVAILABLE_SITES";
export const SELECTED_SITES = "SELECTED_SITES";

/********************************  Getters ********************************/
export const GET_ALL_SITES = "GET_ALL_SITES";
export const GET_SELECTED_SITES = "GET_SELECTED_SITES";
export const GET_SELECTED_SITES_STR = "GET_SELECTED_SITES_STR";

/********************************  Mutations ********************************/
export const SET_ALL_SITES = "SET_ALL_SITES";
export const SET_SELECTED_SITES = "SET_SELECTED_SITES";

/********************************  Actions ********************************/
export const FETCH_ALL_SITES = "FETCH_ALL_SITES";
export const USER_SELECTED_SITES = "USER_SELECTED_SITES";
export const RESET_USER_SELECTED_SITES = "RESET_USER_SELECTED_SITES";
